export default __webpack_public_path__ + "static/media/cube-title-large.6977670f.png";